import { axios } from '@/services/axios';

const getAddressess = async (currentCompany) => {
    const res = await axios.get(`/Addresses/${currentCompany}`);
    return res.data;
};

export default getAddressess;
